<template>
  <option
    :value="value"
    :disabled="disabled"
    :selected="selected"
    :hidden="hidden"
  >
    <slot />
  </option>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      required: true,
    },
  },
}
</script>
